import { compose, lifecycle, withHandlers, withStateHandlers } from 'recompose';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import combineSelectors from 'utils/combineSelectors';
import {
  selectedTemplatesMappings,
  totalSelected,
} from 'reducers/cart/selectors';
import { theme } from 'reducers/dashboard/selectors';
import { submitCart } from 'reducers/cart/actions';
import { addIntlProps, addProps } from 'utils/recompose';
import { injectIntl } from 'react-intl';
import messages from './messages';
import { submissionSuccessPath, submissionFailurePath } from 'utils/paths';
import styles from './styles.module.scss';
import { webShopCloseTime } from 'reducers/dashboard/selectors';
import { checkWebShopClosed } from 'components/SeriesDetail/Root/enhance';

export const updateTime = () => () => ({ currentTime: new Date() });

export function componentDidMount() {
  this.interval = setInterval(() => {
    this.props.updateTime();
  }, 60000);
}

export function componentWillUnmount() {
  clearInterval(this.interval);
}

const mapStateToProps = combineSelectors({
  totalSelected,
  selectedTemplatesMappings,
  theme,
  webShopCloseTime,
});

export const buttonText = ({
  submitOrderString,
  totalSelected,
  isSubmissionButtonDisabled,
}) =>
  isSubmissionButtonDisabled
    ? `${submitOrderString} (0)`
    : `${submitOrderString} (${totalSelected})`;

export const submitOrder = ({
  submitCart,
  selectedTemplatesMappings,
  totalSelected,
  history,
}) => () => {
  return submitCart(selectedTemplatesMappings)
    .then(data => {
      if (data.type === 'SUBMIT_CART_TEMPLATES_REQUEST_SUCCESS') {
        history.push(submissionSuccessPath, { quantity: totalSelected });
      } else {
        history.push(submissionFailurePath, {});
      }
    })
    .catch(() => {
      history.push(submissionFailurePath, {});
    });
};

export const isWebShopClosed = ({ webShopCloseTime }) => {
  let currentTime = new Date();
  let isWebShopClosed = checkWebShopClosed(webShopCloseTime, currentTime);
  return isWebShopClosed;
};

export const isSubmissionButtonDisabled = ({
  disabled,
  totalSelected,
  isWebShopClosed,
}) => {
  let isSubmissionButtonDisabled =
    disabled || totalSelected === 0 || isWebShopClosed;
  return isSubmissionButtonDisabled;
};

export const buttonStyling = ({ isSubmissionButtonDisabled }) =>
  isSubmissionButtonDisabled ? styles.disabled : styles.enabled;

export const themeStyle = ({ isSubmissionButtonDisabled, theme }) =>
  isSubmissionButtonDisabled
    ? {
        background: theme.button.inactiveText,
      }
    : {
        background: theme.palette.primary,
      };

export default compose(
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['submitOrderString'],
  }),
  connect(
    mapStateToProps,
    { submitCart },
  ),
  addProps({ isWebShopClosed }),
  addProps({ isSubmissionButtonDisabled }),
  addProps({ buttonText, buttonStyling, themeStyle }),
  withStateHandlers(() => ({ currentTime: new Date() }), { updateTime }),
  lifecycle({ componentDidMount, componentWillUnmount }),
  addProps({ isWebShopClosed }),
  addProps({ isSubmissionButtonDisabled }),
  addProps({ buttonText, buttonStyling, themeStyle }),
  withRouter,
  withHandlers({ submitOrder }),
);
